exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".text-area{width:100%;border:solid 1px #d3d3d3;border-radius:4px}.text-area.text-area-error{border:1px solid red}.text-area-error-message{color:red;font-size:12px}", ""]);

// exports
